import {useAuth0} from "@auth0/auth0-react";
import MenuIcon from "@mui/icons-material/Menu";
import {Box, Button, IconButton, Menu, MenuItem, useMediaQuery, useTheme} from "@mui/material";
import {useState} from "react";

import {buttonStyle} from "../../../styles/navBarStyle";

import ConnectionStatus from "./ConnectionStatus";

function Profile() {
  const {isAuthenticated, logout, user} = useAuth0();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    window.sessionStorage.clear();
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  if (!isAuthenticated) return null;

  const profileContent = (
    <>
      <ConnectionStatus />
      <span>
        Hi, <b>{user?.given_name ?? user?.family_name ?? user?.name}</b>
      </span>
    </>
  );

  return (
    <Box sx={{display: "flex", alignItems: "center"}}>
      {isSmall ? (
        <>
          <IconButton
            onClick={handleClick}
            sx={{
              color: "inherit",
              padding: "8px",
            }}
          >
            <MenuIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            PaperProps={{
              sx: {
                backgroundColor: "#19191a",
                color: "#fff",
                minWidth: "200px",
              },
            }}
          >
            <MenuItem sx={{fontFamily: "Montserrat"}}>{profileContent}</MenuItem>
            <MenuItem onClick={handleLogout}>Log out</MenuItem>
          </Menu>
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: {sm: 1.5, md: 2},
            flexWrap: "nowrap",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              fontFamily: "Montserrat",
              fontSize: {
                sm: "0.875rem",
                md: "1.1rem",
              },
              whiteSpace: "normal",
              overflow: "visible",
              textOverflow: "unset",
              maxWidth: {
                sm: "250px",
                md: "300px",
              },
            }}
          >
            {profileContent}
          </Box>
          <Button
            sx={{
              ...buttonStyle,
              marginRight: 0,
              fontSize: {
                sm: "0.875rem",
                md: "1rem",
              },
              padding: {
                sm: "6px 12px",
                md: "8px 16px",
              },
              minWidth: {
                sm: "70px",
                md: "80px",
              },
            }}
            onClick={handleLogout}
          >
            Log out
          </Button>
        </Box>
      )}
    </Box>
  );
}

export default Profile;
